import React, { Component } from 'react'
import { infoScreenAriaLabel } from '../Constants/AriaLabelText'
import { sectionData as languageSectionDataFunc } from '../Constants/InfoScreenText'
import { injectIntl, FormattedMessage } from 'react-intl'
// Formatted text JSON map:

export const sectionDataFunc = (isUKEnable, intl) => ({
  action_oriented: {
    Summary: {
      text: (
        <p>
          {intl.formatMessage({
            id: 'infoImpact.actionOriented.summaryText',
            defaultMessage:
              'If you are including bullets in your about section, begin with strong action verbs that inform the Recruiter of the exact actions YOU performed.',
          })}
        </p>
      ),
      correct: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.actionOriented.summaryCorrect',
              defaultMessage:
                'Developed product roadmap and introduced new product features in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      ),
      incorrect: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.actionOriented.summaryIncorrect',
              defaultMessage:
                'Responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      ),
    },
    Experience: {
      text: (
        <p>
          {intl.formatMessage({
            id: 'infoImpact.actionOriented.experienceText',
            defaultMessage:
              'Your experience needs to showcase the work YOU did. Begin your sentences with strong action verbs that inform the Recruiter of the exact actions YOU performed.',
          })}
        </p>
      ),
      correct: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.actionOriented.experienceCorrect',
              defaultMessage:
                'Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      ),
      incorrect: (
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.actionOriented.experienceIncorrect',
              defaultMessage:
                'Responsible for developing product roadmap and introducing new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      ),
    },
  },
  specifics: {
    text: (
      <p>
        {intl.formatMessage(
          {
            id: 'infoImpact.specificsText',
            defaultMessage:
              'Specifics refer to the quantification of outcomes/ impact in your profile. These are outlined by a quantifiable outcome or size and scope of work. Examples include {growthType}, cost, size of your team, or departments you supported.',
          },
          {
            growthType: isUKEnable ? 'turnover' : 'revenue',
          }
        )}
      </p>
    ),
    correct: (
      <div>
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.specificsCorrect',
              defaultMessage:
                'Developed product roadmap and introduced new product features in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth of 15%',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      </div>
    ),
    incorrect: (
      <div>
        <p>
          <span>{String.fromCharCode(9642)} </span>
          {intl.formatMessage(
            {
              id: 'infoImpact.specificsIncorrect',
              defaultMessage:
                'Developed product roadmap and introduced new product feature in collaboration with international cross-functional team; generated ideas to redesign product promotion strategies, leading to {growthType} growth',
            },
            {
              growthType: isUKEnable ? 'turnover' : 'revenue',
            }
          )}
        </p>
      </div>
    ),
  },
})

class InfoImpact extends Component {
  handleTab(id, tabId) {
    $('.as-info-modal-wrapper')
      .find('li')
      .removeClass('active')
      .attr('aria-selected', false)
    $('.as-info-modal-wrapper').find('div').removeClass('show active')
    $(tabId).addClass('active').attr('aria-selected', true)
    $(id).addClass('show active')
  }
  // Formatted text JSON map:
  

  render() {
    const { currentSection, isUKEnable, intl } = this.props
    let sectionData = sectionDataFunc(isUKEnable, intl)
    let languageSectionData = languageSectionDataFunc(isUKEnable)
    return (
      <div>
        <div className="as-info-modal-wrapper">
          <div className="as-info-modal-close">
            <a
              href="javascript:void(0);"
              aria-label={infoScreenAriaLabel(intl)['close']}
              onClick={() => this.props.hideModal()}
              className="icon-cross as-profile-edit-close-btn modal-close-button"
            />
          </div>
          <div className="as-info-modal-heading">
            {intl.formatMessage({
              id: 'aspire.infoImpact.heading',
              defaultMessage: 'Impact',
            })}
          </div>
          <div className="as-info-modal-subheading">
            {intl.formatMessage({
              id: 'aspire.infoImpact.subheading',
              defaultMessage: 'What is Impact?',
            })}
          </div>
          <div className="as-info-modal-desc">
            {intl.formatMessage({
              id: 'aspire.infoImpact.description',
              defaultMessage:
                'Impact refers to the effect of your profile on visitors. It can be measured by the way you have conveyed your actions and their outcomes in your profile. If after reading a sentence, the recruiter immediately notices your action and its effect, you have done a good job in reflecting the impact of your experiences.',
            })}
            {' '}
          </div>
          <div className="as-info-modal-nav">
            <div className="as-info-modal-nav-div">
              <div>
                <ul 
                  className="nav nav-tabs as-info-modal-nav-tabs" 
                  role="tablist"
                  tabIndex={0}
                  style={{ display: 'flex' }}
                >
                  <li
                    role="presentation"
                    className="active"
                    id="action-orientedTab">
                    <a
                      role="tab"
                      aria-selected={true}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.actionOrientedTab.ariaLabel',
                        defaultMessage: 'what are action Oriented sentence?',
                      })}
                      aria-controls="action-oriented"
                      onClick={this.handleTab.bind(
                        this,
                        '#action-oriented',
                        '#action-orientedTab'
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.actionOrientedTab',
                        defaultMessage: 'Action Oriented',
                      })}
                    </a>
                  </li>
                  <li role="presentation" id="specificsTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.specificsTab.ariaLabel',
                        defaultMessage: 'what are specifics in a sentence?',
                      })}
                      aria-controls="specifics"
                      onClick={this.handleTab.bind(
                        this,
                        '#specifics',
                        '#specificsTab'
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.specificsTab',
                        defaultMessage: 'Specifics',
                      })}
                    </a>
                  </li>
                  <li role="presentation" id="avoidedwordsTab">
                    <a
                      role="tab"
                      aria-selected={true}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.avoidedWordsTab.ariaLabel',
                        defaultMessage: 'what are Avoided Words?',
                      })}
                      aria-controls="avoidedwords"
                      onClick={this.handleTab.bind(
                        this,
                        '#avoidedwords',
                        '#avoidedwordsTab'
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.avoidedWordsTab',
                        defaultMessage: 'Avoided Words',
                      })}
                    </a>
                  </li>
                  <li role="presentation" id="verboverusageTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.verbOverusageTab.ariaLabel',
                        defaultMessage: 'check verb Overusage Sample',
                      })}
                      aria-controls="verboverusage"
                      onClick={this.handleTab.bind(
                        this,
                        '#verboverusage',
                        '#verboverusageTab'
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.verbOverusageTab',
                        defaultMessage: 'Verb Overusage',
                      })}
                    </a>
                  </li>
                  <li role="presentation" id="voiceTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.voiceConsistencyTab.ariaLabel',
                        defaultMessage: 'check voice Consistency Sample',
                      })}
                      aria-controls="voice"
                      onClick={this.handleTab.bind(
                        this,
                        '#voice',
                        '#voiceTab '
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.voiceConsistencyTab',
                        defaultMessage: 'Voice Consistency',
                      })}
                    </a>
                  </li>
                  <li role="presentation" id="tenseconsistencyTab">
                    <a
                      role="tab"
                      aria-selected={false}
                      aria-label={intl.formatMessage({
                        id: 'aspire.infoImpact.tenseConsistencyTab.ariaLabel',
                        defaultMessage: 'check tense consistency Sample',
                      })}
                      aria-controls="tenseconsistency"
                      onClick={this.handleTab.bind(
                        this,
                        '#tenseconsistency',
                        '#tenseconsistencyTab'
                      )}
                      data-bs-toggle="tab">
                      {intl.formatMessage({
                        id: 'aspire.infoImpact.tenseConsistencyTab',
                        defaultMessage: 'Tense Consistency',
                      })}
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    role="tabpanel"
                    className="tab-pane fade show active"
                    id="action-oriented">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['action_oriented'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['impact'][
                                    'action_oriented'
                                  ][currentSection]['correct']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {
                                sectionData['action_oriented'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['impact'][
                                    'action_oriented'
                                  ][currentSection]['incorrect']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {
                                sectionData['action_oriented'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div role="tabpanel" className="tab-pane fade" id="specifics">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {sectionData['specifics']['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['impact']['specifics'][
                                    'correct'
                                  ]
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {sectionData['specifics']['correct']}
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['impact']['specifics'][
                                    'correct'
                                  ]
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {sectionData['specifics']['incorrect']}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="avoidedwords">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {languageSectionData['avoidedwords'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {
                                languageSectionData['avoidedwords'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {
                                languageSectionData['avoidedwords'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="verboverusage">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {languageSectionData['verboverusage'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {
                                languageSectionData['verboverusage'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {
                                languageSectionData['verboverusage'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="voice">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {languageSectionData['voice'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">                       
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {
                                languageSectionData['voice'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {
                                languageSectionData['voice'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    role="tabpanel"
                    className="tab-pane fade"
                    id="tenseconsistency">
                    <div className="as-info-modal-nav-content">
                      <div 
                        className="as-info-modal-nav-content-desc"
                      >
                        {languageSectionData['tenseconsistency'][currentSection]['text']}
                      </div>
                      <h3
                        className="smp-heading"
                        tabIndex={0}
                        aria-label={intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}>
                          {' '}
                        {intl.formatMessage({
                          id: 'aspire.infoImpact.sampleBulletsHeading',
                          defaultMessage: 'Sample Bullets',
                        })}
                      </h3>
                      <div className="row as-info-modal-nav-content-row">
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-green">
                              <i className="fa fa-thumbs-up" aria-hidden="true" />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['correct']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.correctWay',
                                  defaultMessage: 'Correct way',
                                })}
                              </div>
                              {
                                languageSectionData['tenseconsistency'][currentSection][
                                  'correct'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                        <div className="col-sm-6 smp-bullets">
                          <div className="smp-bullets-sec">
                            <div className="smp-icon smp-red">
                              <i
                                className="fa fa-thumbs-down"
                                aria-hidden="true"
                              />
                            </div>
                            <div className="smp-data">
                              <div
                                className="smp-data-heading"
                                tabIndex={0}
                                role="heading"
                                aria-label={
                                  infoScreenAriaLabel(intl)['language']['sectionData'][
                                    'avoidedwords'
                                  ][currentSection]['incorrect']
                                }>
                                {intl.formatMessage({
                                  id: 'aspire.infoImpact.incorrectWay',
                                  defaultMessage: 'Incorrect way',
                                })}
                              </div>
                              {
                                languageSectionData['tenseconsistency'][currentSection][
                                  'incorrect'
                                ]
                              }
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default injectIntl(InfoImpact)


